import { observable } from "mobx";


export default class DadosRetiradaStore {

    @observable dtRetirada;
    @observable preferencias;
    @observable referenciaCliente;
    
    constructor(service) {
        
        this.dtRetirada = null;
        this.referenciaCliente = ""
        this.preferencias = {
            incluirDtRetCalculo: false,
            pagarDiaPorta: false,
            desovaHouse: false,
            retiradaBarcaca: false
        }
        this.service = service;
    }

    setDataRetirada = (value) => {
        this.dtRetirada = value;
    }

    setPreferencia = (value, param) => {
        this.preferencias[param] = value;
    }

    setReferencia = (value) => {
        this.referenciaCliente = value;
    }

}


// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/stores/DadosRetiradaStore.js